import { Navigate, useLocation } from "react-router-dom";

const ADMIN_AUTH_KEY = "QV_ADMIN_AUTH";

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = sessionStorage.getItem(ADMIN_AUTH_KEY) === "true";

  if (!isLoggedIn) {
    return <Navigate to="/admin" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth;
